import { GroupModel } from "./Group";
import { Pathology } from "./Pathology";

export enum UserRole {
  ADMIN = "admin",
  DOCTOR = "doctor",
  PATIENT = "patient",
  RESEARCHER = "researcher",
  CAREGIVER = "caregiver"
}

export interface RefDoctor {
  id: number
  name: string
}

export class UserCredentials {
  username: string;
  password: string;

  constructor() {
    this.username = '';
    this.password = '';
  }
}

export class User {
  email: string;
  firstname: string;
  groups?: GroupModel[];
  lastname: string;
  pathology?: Pathology;
  role: UserRole;
  username: string;
  taxCode?: string;
  password?: string;
  id?: number;
  refDoctor?: RefDoctor;
  idOrg?: number;
  privacyMode?: boolean;
  caregiver?: Caregiver

  constructor() {
    this.email = "";
    this.firstname = "";
    this.lastname = "";
    this.groups = [];
    this.pathology = undefined;
    this.taxCode = "";
    this.role = UserRole.PATIENT;
    this.username = "";

  }
}

export class UserDTO {
  email: string;
  firstname: string;
  groups?: GroupModel[];
  lastname: string;
  pathology?: number;
  role: UserRole;
  username: string;
  taxCode?: string;
  id?: number;
  refDoctor?: RefDoctor;
  password?: string;
  caregiver?: Caregiver

  constructor(user?: User) {
    this.email = user?.email || "";
    this.firstname = user?.firstname || "";
    this.lastname = user?.lastname || "";
    this.groups = user?.groups || [];
    this.pathology = user?.pathology?.id || undefined;
    this.taxCode = user?.taxCode || "";
    this.role = user?.role || UserRole.PATIENT;
    this.username = user?.username || "";
    this.id = user?.id || undefined;
    this.caregiver = user?.caregiver || new Caregiver()
  }
}

export class Caregiver {
  id?: string
  username?: string
  password?: string
  firstname?: string
  lastname?: string
  phone?: string
  email?: string

  constructor() {

    this.username = ""
    this.password = ""
    this.firstname = ""
    this.lastname = ""
    this.phone = ""
    this.email = ""


  }
}